import React from 'react';
import { triggerOpenOrderSummary } from '|/hooks/use-open-order-summary';
import PriceIsRightPayAtOrder from './pay-at-order';
import { PriceIsRightContent } from './price-is-right-content';
import CompletePurchaseShell from '../complete-purchase-shell';
import type {
  CompletePurchasePayAtOrderRenderProps,
  CompletePurchasePriceDetailsRenderProps
} from '../complete-purchase-shell';
import type { CompletePurchaseStepProps } from '../complete-purchase.types';

const renderPayAtOrder = (props: CompletePurchasePayAtOrderRenderProps) => (
  <PriceIsRightPayAtOrder {...props} />
);

const renderPriceDetails = ({
  paymentSummary,
  reviewSummary
}: CompletePurchasePriceDetailsRenderProps) => (
  <PriceIsRightContent
    paymentSummary={paymentSummary}
    reviewSummary={reviewSummary}
    onViewPriceDetails={() => {
      if (reviewSummary) triggerOpenOrderSummary();
    }}
  />
);

const CompletePurchaseTreatment: React.FC<CompletePurchaseStepProps> = props => {
  return (
    <CompletePurchaseShell
      {...props}
      renderPayAtOrder={renderPayAtOrder}
      renderPriceDetails={renderPriceDetails}
    />
  );
};

export default CompletePurchaseTreatment;
